import { AsyncPipe, NgClass } from '@angular/common';
import {
    Component,
    ComponentFactoryResolver,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { DecorationService } from 'app/core/decorations/decoration.service';
import { DecorationConfig } from 'app/core/decorations/decoration.types';
import { Observable, Subject, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'app-empty-layout',
    templateUrl: './empty.component.html',
    styleUrl: './empty.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [FuseLoadingBarComponent, RouterOutlet, NgClass, AsyncPipe],
})
export class EmptyLayoutComponent implements OnInit, OnDestroy {
    public layout$!: Observable<'full' | 'split'>;

    private _decorationConfig: DecorationConfig | null = null;

    private _unsubscribeAll = new Subject<null>();

    @ViewChild('decorationComponent', { read: ViewContainerRef, static: false })
    set decorationComponentRef(ref: ViewContainerRef) {
        if (ref && this._decorationConfig) {
            const component = this._decorationConfig.component;

            if (component && ref) {
                const componentFactory =
                    this.componentFactoryResolver.resolveComponentFactory(
                        component
                    );
                ref.createComponent(componentFactory);
            }
        }
    }

    constructor(
        private readonly _decorationService: DecorationService,
        private readonly componentFactoryResolver: ComponentFactoryResolver
    ) {}

    ngOnInit(): void {
        this.layout$ = this._decorationService.layout$;

        this._decorationService.config$
            .pipe(
                takeUntil(this._unsubscribeAll),
                tap((config) => (this._decorationConfig = config))
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
